import React, { Component } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import { Doughnut } from 'react-chartjs-2';
import "../../dashboard/dashboard.scss"
import Icon from "../../common/icon/icon.component.jsx";

const options = {
    legend: {
        display: false,
        labels: {
            fontColor: 'rgb(255, 99, 132)'
        },
        position: "bottom",
    },
    maintainAspectRatio: false,
    cutoutPercentage: 90
}


const messages = defineMessages({
    "time_spent_on_content_legend": {
        id: 'dashboard.stat.doughnut.time_spent_on_content_legend',
        defaultMessage: 'Seconds spent on content',
    },
    "time_spent_on_pricing_legend": {
        id: 'dashboard.stat.doughnut.time_spent_on_pricing_legend',
        defaultMessage: 'Seconds spend on pricing',
    },

})


class ProposalTimeSpentDoughnut extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            visits: this.props.visits || 0,
            totalTimeSpent: this.props.totalTimeSpent || 0,
            totalTimeSpentOnPricing: this.props.totalTimeSpentOnPricing || 0,
            proposalType: this.props.proposalType || 'quote',
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visits: nextProps.visits || 0,
            totalTimeSpent: nextProps.totalTimeSpent || 0,
            totalTimeSpentOnPricing: nextProps.totalTimeSpentOnPricing || 0,
            proposalType: nextProps.proposalType || 'quote',
        })
    }

    render() {

        const colorContent = '#6b6a74';
        const colorPricing = '#E9235C'

        const data = {
            labels: [
                this.props.intl.formatMessage(messages['time_spent_on_content_legend']),
                this.props.intl.formatMessage(messages['time_spent_on_pricing_legend']),
            ],
            datasets: [{
                data: [
                    this.state.totalTimeSpent - this.state.totalTimeSpentOnPricing,
                    this.state.totalTimeSpentOnPricing,
                ],
                backgroundColor: [
                    colorContent,
                    colorPricing,
                ],
                hoverBackgroundColor: [
                    '#9695a3',
                    '#db6670',
                ]
            }]
        }

        let mainNumber = ''
        if (this.state.totalTimeSpent < 60) {
            mainNumber = <span>{this.state.totalTimeSpent} <small>sec</small></span>
        } else if (this.state.totalTimeSpent > 3600) {
            const totalNumberOfHours = Math.round(this.state.totalTimeSpent / 3600)
            mainNumber = <span>{totalNumberOfHours} <small>h</small></span>
        } else {
            const totalNumberOfMinutes = Math.round(this.state.totalTimeSpent / 60)
            mainNumber = <span>{totalNumberOfMinutes} <small>min</small></span>
        }
        const badge = <span style={{ fontSize: '1rem' }} className={'badge badge-pill text-white ' + (this.state.visits.length > 0 ? 'badge-success' : 'badge-warning')}><FormattedMessage
            id="quote.analytics.doughnut.nb_views_on_proposal"
            defaultMessage="{viewsCount, plural, =0 {no view yet} one {# view} other {# views}}"
            values={{
                viewsCount: this.state.visits.length
            }}
        /></span>
        let title = <FormattedMessage
            id="quote.analytics.doughnut.time_spent_on_proposal"
            defaultMessage="Total time spent on the proposal {nbViews}"
            values={{
                nbViews: badge
            }}
        />
        if (this.state.proposalType === "invoice") {
            title = <FormattedMessage
                id="invoice.analytics.doughnut.time_spent_on_proposal"
                defaultMessage="Total time spent on the invoice {nbViews}"
                values={{
                    nbViews: badge
                }}
            />
        }
        return (
            <div className="h-100">
                <div className="dashboard-stats-box-no-border time-spent-stats-box-doughnut p-0">
                    <div className="col-form-label custom-form-label pt-0 pb-2">
                        <strong>
                            {title}
                        </strong>
                    </div>

                    <div className="dashboard-stats-doughnut-text-box d-table centered mb-2">
                        <div className="display-4 dashboard-stat-doughnut-value d-table-cell align-middle">
                            {mainNumber}
                        </div>
                    </div>
                    <div className="centered">
                        <Doughnut data={data} options={options} width={100} height={100} />
                    </div>

                    <div className="dashboard-stats-doughnut-legend bottomed mt-3">
                        <div className="w-100" style={{ color: colorContent }}>
                            <Icon value={"align-left"} />
                            <FormattedMessage
                                id="quote.analytics.doughnut.time_spent_on_content"
                                defaultMessage="Time spent on content"
                            /></div>
                        <div className="w-100" style={{ color: colorPricing }}>
                            <Icon value={"dollar-sign"} />
                            <FormattedMessage
                                id="quote.analytics.doughnut.time_spent_on_pricing"
                                defaultMessage="Time spent on pricing"
                            /></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ProposalTimeSpentDoughnut)





// WEBPACK FOOTER //
// ./src/quote/analytics/timespentdoughnut.component.jsx